import './jquery.accordion.js'

$(() => {
  $('.wpce-accordion').Accordion({
    toggleContainer: '.accordion-inner',
    toggleButton: '.accordion-heading',
    toggleClass: 'accordion-open',
  })
})
